import { render, staticRenderFns } from "./serveCostRecord.vue?vue&type=template&id=795a6cc7&scoped=true&"
import script from "./serveCostRecord.vue?vue&type=script&lang=js&"
export * from "./serveCostRecord.vue?vue&type=script&lang=js&"
import style0 from "./serveCostRecord.vue?vue&type=style&index=0&id=795a6cc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a6cc7",
  null
  
)

export default component.exports